/**
 * Étendues qu'une satisfaction peut proposer : de la note la plus basse à la plus haute.
 *
 * La valeur est ce qui s'affiche : deux nombres séparés d'un trait se lisent dans toutes les
 * langues, il n'y a rien à traduire. Les crans se déduisent de l'une et l'autre borne.
 */
export enum CSAT_RANGE {
    ONE_TO_FOUR = '1-4',
    ONE_TO_FIVE = '1-5',
    ZERO_TO_TEN = '0-10',
}
